import { Component, Input, OnInit } from '@angular/core';
import * as Highcharts from "highcharts";
import HighchartsMore from "highcharts/highcharts-more";
HighchartsMore(Highcharts);
import HC_solid_gauge from "highcharts/modules/solid-gauge";
HC_solid_gauge(Highcharts);
@Component({
  selector: 'app-gauge-chart',
  templateUrl: './gauge-chart.component.html',
  styleUrls: ['./gauge-chart.component.scss']
})
export class GaugeChartComponent implements OnInit {
  defaultData = { Value: 0 };
  height:any
@Input('ChartData')
set in(val:any){
  if (val) {
    val.Value =Number(Number(parseFloat(val.Value).toFixed(2)));
    this.height=val.height
    if(val.type=='solidgauge'){
    this.solidgauagechart(val)
    }else{
      this.plotGraph(val);
    }

  } else {
    this.plotGraph(this.defaultData);
  }
}
  constructor() { }
  highcharts = Highcharts;

  solidGaugeChartOptions = {};
  ngOnInit(): void {
  }
  plotGraph(data:any) {
    return (this.solidGaugeChartOptions = {
      chart: {
        type:"gauge",
        plotBackgroundColor: null,
        plotBackgroundImage: null,
        plotBorderWidth: 0,
        plotShadow: false,
        spacing: 0,
        backgroundColor: "transparent",
        marginBottom:data.mb?data.mb:10,
        marginTop:data.mt?data.mt:10,
        marginLeft:data.ml?data.ml:10,
        marginRight:data.mr?data.mr:10
      },

      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      pane: {
        startAngle: data.startAngle?data.startAngle:-180,
        endAngle: data.endAngle?data.endAngle:180,
        size: data.chartSize?data.chartSize:"90%",
        // outerRadius: "100%",
        // innerRadius: "60%",
        background: [
        {
          borderWidth: 1,
          borderRadius: 6,
          borderColor: '#EEEEEE',
        },
        {
          backgroundColor:' #FFFFFF',
          borderColor: '#EEEEEE',
        },
        ],
      },


      // the value axis
      yAxis: {
        min: 0,
        max: 100,
        lineColor: null,
        minorTickInterval: "auto",
        minorTickWidth: 0,
        minorTickLength: 10,
        minorTickPosition: "inside",
        minorTickColor: "#fff",
        tickPixelInterval: 30,
        tickWidth: 0,
        tickPosition: "outside",
        tickLength: 10,
        tickColor: "#666",
        startOnTick: false,
        minPadding: 100,
        labels: {
          step: data.dataLabels.step?data.dataLabels.step:2,
          rotation: "auto",
          overflow: "justify",
          distance: -20,
          style:data.dataLabels.style?data.dataLabels.style: {
            color: "#fff",
            fontWeight: "500",
            marginBottom: 100,
            fontSize: 13,
          },
        },
        title: {
          text: "",
        },
        plotBands: [
          {
            from: 65,
            to: 100,
            innerRadius: "70%",
            color: "#467BC9", // 65-100
          },
          {
            from: 65,
            to: 85,
            innerRadius: "70%",
            color: "#A8CBFF", // 65-85
          },
          {
            from: 0,
            to: 65,
            innerRadius: "70%",
            color: "#5599FF", // 0-65
          },
        ],
      },

      tooltip: {
        time: {
          useUTC: false,
        },
        pointFormat:
          '<tr style="font-size:14px;"><td style="color:{series.color};padding:0">{series.name}: </td>' +
          '<td style="padding:0"><b>{point.y:.2f} ' +
          "%" +
          "</b></td></tr>",
        footerFormat: "</table>",
        shared: true,
        useHTML: true,
        backgroundColor: "#eeeeee",
        borderColor: "#eeeeee",
      },
      plotOptions: {
        solidgauge: {
          pointStart: 30,
          innerRadius: "60%",
          rounded: true,
          shadow: {
            borderRadius: 50,
            color: '#d8d8d8',
            offsetX: 0,
            offsetY: 0,
            opacity: 1,
            width: 6
        },
        },
      },
      series: [
        {
          name: data.name || "Value",
          data: [data.Value],
          tooltip: {
            valueSuffix: "",
          },
          dataLabels: {
            enabled: true,
            color: "black",
            fontWeight: "lighter",
            format: `${data.Value} %`,
            style: {
              fontSize: 15,
            },
            // backgroundColor: "white",
          },
          dial: {
            radius: '60%',
            backgroundColor: '#D8D8D8',
            baseWidth: 12,
            baseLength: '0%',
            rearLength: '0%'
        },
        pivot: {
            backgroundColor: '#D8D8D8',
            radius: 6
        }
        },
      ],

    });
  }
  solidgauagechart(data) {
    const chartHeight = data.height ? parseInt(data.height) : 135;
    return (this.solidGaugeChartOptions = {
      chart: {
        type: "solidgauge",
        backgroundColor: "transparent",
        reflow: true,
        height: chartHeight,
        style: { fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif" },
        marginBottom: data.mb !== undefined ? data.mb : 0,
        marginTop: data.mt !== undefined ? data.mt : 0,
        marginLeft: data.ml !== undefined ? data.ml : 0,
        marginRight: data.mr !== undefined ? data.mr : 0,
        spacing: [0, 0, 0, 0],
      },
      credits: {
        enabled: false,
      },
      title: {
        text: "",
      },
      subtitle: {
        text: "",
      },
      legend: {
        enabled: false,
      },
      pane: {
        center: ["50%", "50%"],
        startAngle: data.startAngle !== undefined ? data.startAngle : -170,
        endAngle: data.endAngle !== undefined ? data.endAngle : 170,
        size: data.chartSize ? data.chartSize : "95%",
        background: {
          backgroundColor: data.trackcolor ? data.trackcolor : "#f1f5f9",
          innerRadius: data.innerRadius ? data.innerRadius : "72%",
          outerRadius: data.outerRadius ? data.outerRadius : "90%",
          borderWidth: 0,
          shape: "arc",
        },
      },
      yAxis: {
        min: 0,
        max: 100,
        lineWidth: 0,
        tickPositions: [],
        labels: {
          enabled: false,
        },
      },
      tooltip: {
        enabled: false,
      },
      plotOptions: {
        solidgauge: {
          innerRadius: data.innerRadius ? data.innerRadius : "72%",
          outerRadius: data.outerRadius ? data.outerRadius : "90%",
          linecap: "round",
          rounded: true,
          dataLabels: {
            enabled: true,
            borderWidth: 0,
            useHTML: true,
          },
        },
      },
      series: [
        {
          type: "solidgauge",
          showInLegend: false,
          name: data.name ? data.name : "",
          data: [
            {
              color: data.plotcolor ? data.plotcolor : "#10b981",
              radius: data.radius ? data.radius : "90%",
              innerRadius: data.innerRadius ? data.innerRadius : "72%",
              y: Math.min(parseFloat(data.Value) || 0.01, 100),
              dataLabels: {
                y: -20,
                useHTML: true,
                formatter: function () {
                  return data.showLabel
                    ? `<div style="text-align:center;line-height:1.2;font-family:inherit;pointer-events:none;user-select:none;">
                        <div style="font-size:10px;font-weight:700;letter-spacing:0.06em;text-transform:uppercase;color:#64748b;margin-bottom:1px;">LIFECYCLE</div>
                        <div style="font-size:18px;font-weight:700;color:#0f172a;line-height:1.1;">${parseFloat(data.life_cycle) || 0}</div>
                        <div style="font-size:10px;font-weight:600;color:#94a3b8;margin-top:1px;">Days</div>
                      </div>`
                    : ``;
                },
                borderWidth: 0,
              },
            },
          ],
        },
      ],
    });
  }

}
